import script from "./CoordinateCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoordinateCell.vue?vue&type=script&setup=true&lang=ts"

import "./CoordinateCell.vue?vue&type=style&index=0&id=41c515d6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41c515d6"]])

export default __exports__